import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const softwareCalendarClassicCustomEmbedRoute: InvariantJiraRoute = {
	name: 'software-calendar-classic-custom-embed',
	path: '/jira/software/c/projects/:projectKey/boards/:boardId/calendar/:itemId/embed',
	query: ['date?'],
};
